import selectn from "selectn";
import { BLOCK_TYPE, EMBED_TYPE } from "config/constants";

const UNSUPPORTED_EMBEDS = [EMBED_TYPE.ART19];

function blockIsUnsupported(block) {
  // Don't support Axios Visuals without dimensions in AMP
  if (
    block.type === BLOCK_TYPE.EMBED &&
    block.data.type === EMBED_TYPE.AXIOS_VISUAL
  ) {
    return !(
      selectn("data.oembed.apple_fallback_dimensions.width", block) &&
      selectn("data.oembed.apple_fallback_dimensions.height", block) &&
      selectn("data.oembed.newsletter_fallback_dimensions.width", block) &&
      selectn("data.oembed.newsletter_fallback_dimensions.height", block)
    );
  }

  // Don't support Document Cloud and Art19 in AMP
  if (block.type === BLOCK_TYPE.EMBED) {
    return UNSUPPORTED_EMBEDS.includes(block.data.type);
  }

  return;
}

/**
 * @param {object} content - a content object
 * @param {object} content.blocks - the draft-js object representing a story
 * @param {array} content.blocks.entityMap - the draft-js entities
 * @param {array} content.blocks.blocks - the draft-js blocks
 */
export default function isPermalinkSupportedInAMP(content) {
  const { blocks } = content;
  return blocks.blocks.every(block => !blockIsUnsupported(block));
}
